import { render, staticRenderFns } from "./dialog-table-button.vue?vue&type=template&id=93efa258"
import script from "./dialog-table-button.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog-table-button.vue?vue&type=script&setup=true&lang=js"
import style0 from "./dialog-table-button.vue?vue&type=style&index=0&id=93efa258&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports